import React from 'react';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';
import { useRealizedGainLoss } from '../../../../../../hooks/useRealizedGainLoss';
import { DesktopTotals } from './components/DesktopTotals/DesktopTotals';
import { MobileTotals } from './components/MobileTotals/MobileTotals';
import { TotalsLoading } from './Totals.loading';

interface Props {
  title: string;
}

export const Totals = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const { isFetching, data } = useRealizedGainLoss();

  if (isFetching) {
    return <TotalsLoading isEmbeddedMobile={isEmbeddedMobile} title={title} />;
  }

  if (!data) {
    return null;
  }

  const realizedGainLossTotals = data?.totals;

  if (
    !realizedGainLossTotals ||
    realizedGainLossTotals.shortTerm == null ||
    realizedGainLossTotals.longTerm == null ||
    realizedGainLossTotals.total == null
  ) {
    return null;
  }

  if (isEmbeddedMobile) {
    return <MobileTotals {...realizedGainLossTotals} title={title} />;
  }

  return <DesktopTotals {...realizedGainLossTotals} title={title} />;
};
